import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ResourceLabel = ({ resource, intl }) => (
  <FormattedMessage 
    id={'resource.label.' + resource.id} 
    defaultMessage={resource.id}
    />
);

ResourceLabel.propTypes = {
  resource: PropTypes.object.isRequired,
}

export default ResourceLabel;


// WEBPACK FOOTER //
// ./src/components/resources/ResourceLabel.js